import React from "react";
import styled, { keyframes } from "styled-components";
import { useCartContext } from "../context/cart_context";
import { formatPrice } from "../utils/helpers";

const CartTotals = ({ isSending }) => {
  const { total_amount, total_bail, total_amount_weekend } = useCartContext();

  return (
    <Wrapper>
      <div className="totals-card">
        <h4 className="title">Souhrn objednávky</h4>

        <ul className="rows">
          <li>
            <span>Pronájem za 1 den</span>
            <strong>{formatPrice(total_amount)}</strong>
          </li>
          <li>
            <span>Pronájem na víkend</span>
            <strong>{formatPrice(total_amount_weekend)}</strong>
          </li>
          <li className="bail">
            <span>
              Vratná kauce
              <em>vrácena po akci</em>
            </span>
            <strong>{formatPrice(total_bail)}</strong>
          </li>
        </ul>

        <p className="note">
          Cena za víkend platí pro pronájem pá–ne. Kauce se vrací při vrácení vybavení v pořádku.
        </p>
        <p className="note vat">Ceny jsou bez DPH.</p>

        <button
          className="submit-btn"
          type="submit"
          form="my-form"
          disabled={isSending}
        >
          {isSending ? (
            <>
              <span className="btn-spinner" aria-hidden="true" />
              Odesíláme…
            </>
          ) : (
            "Odeslat nezávaznou poptávku"
          )}
        </button>
      </div>
    </Wrapper>
  );
};

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const Wrapper = styled.section`
  margin-top: 1.5rem;
  display: flex;
  justify-content: center;

  .totals-card {
    width: 100%;
    max-width: 520px;
    background: var(--clr-paper);
    border: 1px solid var(--clr-divider);
    border-radius: var(--radius-lg);
    padding: 1.75rem;
    box-shadow: var(--shadow-sm);
  }

  .title {
    font-family: var(--ff-display);
    color: var(--clr-charcoal-1);
    margin-bottom: 1.25rem;
    text-transform: none;
    letter-spacing: 0;
  }

  .rows {
    list-style: none;
    padding: 0;
    margin: 0 0 1.25rem;
  }
  .rows li {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    padding: 0.75rem 0;
    border-bottom: 1px dashed var(--clr-divider);
    gap: 1rem;
  }
  .rows li:last-child {
    border-bottom: none;
  }
  .rows li span {
    color: var(--clr-charcoal-2);
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
  }
  .rows li em {
    font-style: normal;
    font-size: 0.78rem;
    color: var(--clr-charcoal-3);
  }
  .rows li strong {
    font-family: var(--ff-display);
    font-size: 1.2rem;
    color: var(--clr-charcoal-1);
  }
  .rows li.bail strong {
    color: var(--clr-accent-dark);
  }

  .note {
    color: var(--clr-charcoal-3);
    font-size: 0.85rem;
    font-style: italic;
    margin: 0 0 0.5rem;
    line-height: 1.5;
  }
  .note.vat {
    text-align: right;
    font-weight: 600;
    color: var(--clr-charcoal-2);
    margin-bottom: 1.25rem;
  }

  .submit-btn {
    width: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.6rem;
    background: var(--clr-accent);
    color: var(--clr-paper);
    border: none;
    border-radius: var(--radius-pill);
    padding: 1rem 1.5rem;
    font-family: var(--ff-body);
    font-weight: 700;
    font-size: 1.05rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    cursor: pointer;
    transition: var(--transition);
    box-shadow: var(--shadow-sm);
  }
  .submit-btn:hover {
    background: var(--clr-accent-dark);
    box-shadow: var(--shadow);
    transform: translateY(-1px);
  }
  .submit-btn:active {
    transform: scale(0.99);
  }
  .submit-btn:disabled {
    opacity: 0.75;
    cursor: wait;
    transform: none;
    box-shadow: var(--shadow-sm);
  }
  .submit-btn:disabled:hover {
    background: var(--clr-accent);
  }

  .btn-spinner {
    width: 1.1em;
    height: 1.1em;
    flex-shrink: 0;
    border-radius: 50%;
    border: 2px solid rgba(255, 255, 255, 0.35);
    border-top-color: var(--clr-paper);
    animation: ${spin} 0.8s linear infinite;
  }

  @media (min-width: 776px) {
    justify-content: flex-end;
    .totals-card {
      padding: 2rem 2.25rem;
    }
  }
`;

export default CartTotals;
